module.exports = "<div class=\"login-info\">\n  <span *ngIf=\"profile?.picture\"><a> <!--(click)=\"toggleShortcut()\"-->\n\t   <!--<img [src]=\"user.picture\" alt=\"me\"-->\n      <img src=\"assets/img/avatars/nopic_192.gif\" alt=\"me\"\n          class=\"online\"/><span>{{profile?.name }}</span> <!--<i class=\"fa fa-angle-down\"></i>-->\n    </a>\n   </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/alex/Documents/JC/JC3 3/src/app/shared/user/login-info/login-info.component.html
// module id = ../../../../../src/app/shared/user/login-info/login-info.component.html
// module chunks = main